export default {
    ID: {
        clienteMetta: 0,
        operador: 1,
        franquiado: 2,
        operadorMaster: 3,
        secretariaMaster: 4,
        administrador: 5,
        bioMedicina: 6
    }
}


// WEBPACK FOOTER //
// ./src/helpers/perfil.js